import { Linking, StyleSheet, Text, View } from 'react-native';
import React, { FC } from 'react';
import { Image } from '../../../components/Image';
import { STYLE_VARS } from '../../../constants/style-vars';
import { Button } from '../../../components/Button';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';
import { COLORS, FONTS } from '../../../constants';
import { IDiningMenu } from '../../../types/menus.types';
import { htmlDecode } from '../../../services/utils/htmlDecode';

interface DinningMenuItemProps {
  item: IDiningMenu;
}

const DinningMenuItem: FC<DinningMenuItemProps> = ({ item }) => {
  const isDesktop = useIsDesktop();
  return (
    <View
      style={{
        paddingBottom: 20,
        marginBottom: 20,
        borderBottomColor: STYLE_VARS.fccDarkGrey,
        borderBottomWidth: 0.5,
        flexDirection: isDesktop() ? 'row' : undefined,
      }}
    >
      {item.thumb && (
        <Image
          source={{ uri: item.thumb }}
          style={{
            width: isDesktop() ? 300 : '100%',
            marginRight: isDesktop() ? 20 : 0,
            height: 230,
            resizeMode: 'cover',
            marginBottom: 5,
          }}
        />
      )}
      <View
        style={{ flexDirection: isDesktop() ? 'column' : undefined, flex: 1 }}
      >
        <View style={{ paddingVertical: 10 }}>
          <Text style={styles.title}>{item.title}</Text>
        </View>
        <View style={{}}>
          <Text style={styles.text}>{htmlDecode(item.content)}</Text>
        </View>
        <View
          style={{
            flexDirection: 'row',
            marginTop: 5,
            alignSelf: isDesktop() ? 'flex-start' : undefined,
            flexWrap: 'wrap',
          }}
        >
          {item.additional_fields.map((menu) => (
            <View
              style={{
                marginRight: 5,
              }}
            >
              <Button
                key={menu.button_text}
                text={menu.button_text.toUpperCase()}
                style={STYLE_VARS.blueButton}
                onPress={() => {
                  if (menu.button_type === 'link') {
                    Linking.openURL(menu.button_link);
                  } else {
                    if (menu.button_file.url) {
                      Linking.openURL(menu.button_file.url);
                    }
                  }
                }}
              />
            </View>
          ))}
        </View>
      </View>
    </View>
  );
};

export default DinningMenuItem;

const styles = StyleSheet.create({
  title: {
    fontFamily: FONTS.IowanOldStyleBTRoman,
    fontSize: 18,
    fontWeight: '500',
    color: COLORS.GREEN,
    textTransform: 'uppercase',
  },
  text: {
    fontFamily: FONTS.AvenirMedium,
    fontSize: 13,
    fontWeight: '500',
    color: COLORS.DARKER_GREY,
    textTransform: 'uppercase',
  },
});
